import { Heading, makeClassName, Modal, ModalProps, Row } from "@hex-insights/core";
import { Icon, IconContainer } from "../../../../Components/Icon";
import { StudentMedicalEvent, useStudentMedicalEventDetailQuery } from "../../../../Utilities";
import { DetailDisplayStudentMedicalEvent, StudentMedicalEventDetailDisplay } from "../DetailDisplay";
import styles from "./styles.module.css";

export type ControlledStudentMedicalEventModalProps = Omit<StudentMedicalEventModalProps, "studentMedicalEvent"> & {
	studentMedicalEventID: StudentMedicalEvent["id"];
};

export function ControlledStudentMedicalEventModal({
	studentMedicalEventID,
	...props
}: ControlledStudentMedicalEventModalProps) {
	const { loading, data } = useStudentMedicalEventDetailQuery({ variables: { id: studentMedicalEventID } });

	return <StudentMedicalEventModal isLoading={loading} studentMedicalEvent={data?.studentMedicalEvent} {...props} />;
}

export type ModalStudentMedicalEvent = DetailDisplayStudentMedicalEvent;

export type StudentMedicalEventModalProps = {
	isLoading?: boolean;
	studentMedicalEvent: ModalStudentMedicalEvent | null | undefined;
} & Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">;

export function StudentMedicalEventModal({
	isLoading,
	studentMedicalEvent,
	ifRef,
	onClose,
	className,
	style,
}: StudentMedicalEventModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={makeClassName(styles["modal"], className)} style={style}>
			<Modal.Header>
				<Row justify="spaced-start" align="center">
					<IconContainer color="var(--theme-colors__pink--background)">
						<Icon.FirstAidKit color="var(--theme-colors__pink)" size={22} />
					</IconContainer>

					<Heading.H2 noMargin>Medical Event</Heading.H2>
				</Row>
			</Modal.Header>
			<Modal.Body>
				<StudentMedicalEventDetailDisplay isLoading={isLoading} studentMedicalEvent={studentMedicalEvent} />
			</Modal.Body>
		</Modal>
	);
}
